import ServiceView from "./ServiceView";

export default ServiceView;
